

import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import useApi from "../../../CustomHooks/useApi";
import Popup from "../../../ResuableCompoment/Popup";
import { fetchAepsBalance, fetchSettlementBalance, fetchWalletBalance } from "../../../Store/Slices/WalletSlice";

const AddBeneficiarySolitech = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();

    // Context from route navigation
    const remitter_mobile = location.state?.mobile;
    const mobile_number = useSelector((state) => state.auth?.employeeDetails?.mobile_number);
    const username = useSelector((state) => state.auth?.employeeDetails?.username);

    // Form action APIs
    const { callApi: addBene } = useApi("/soliteck/bene/add", "POST");
    const { callApi: fetchBanksApi } = useApi("/soliteck/banks", "GET");
    const { callApi: fetchIfscApi, loading: loadingIfsc } = useApi("/soliteck/ifsc", "GET"); 

    // UI Feedback State Control
    const [isLoading, setIsLoading] = useState(false);
    const [showPopup, setShowPopup] = useState(false);
    const [popupMessage, setPopupMessage] = useState("");
    const [popupType, setPopupType] = useState("");

    // Dynamic Form States
    const [allBanks, setAllBanks] = useState([]);
    const [bank, setBank] = useState("");
    const [bankCode, setBankCode] = useState("");
    const [ifsc, setIfsc] = useState("");
    const [accountNumber, setAccountNumber] = useState("");
    const [beneficiaryName, setBeneficiaryName] = useState("");
    const [isVerifyAction, setIsVerifyAction] = useState(false); 
    const [showNameInput, setShowNameInput] = useState(false); // ✅ Controls visibility of Beneficiary Name

    // Filtering & Dropdown States
    const [searchTerm, setSearchTerm] = useState("");
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [showOtherBanks, setShowOtherBanks] = useState(false);
    const [errors, setErrors] = useState({});
    const [showConfirm, setShowConfirm] = useState(false);
    const dropdownRef = useRef(null);

    // Fetch banks dynamically on component mount
    useEffect(() => {
        const getBanks = async () => {
            try {
                const res = await fetchBanksApi();
                if (res && Array.isArray(res)) {
                    const mappedBanks = res.map(b => ({
                        bank_name: b.BankName || "", 
                        bank_code: b.BankCode ? b.BankCode.trim() : "", 
                        ifsc_code_sample: ""
                    }));
                    setAllBanks(mappedBanks);
                }
            } catch (error) {
                console.error("Failed to fetch banks", error);
            }
        };
        getBanks();
    }, []);

    // Grid configuration bank mappings
    const bankMappings = [
        { short: "SBI", full: "State Bank of India" },
        { short: "PUNB", full: "Punjab National Bank" },
        { short: "BARB", full: "BANK OF BARODA" },
        { short: "BKID", full: "BANK OF INDIA" },
        { short: "UBIN", full: "UNION BANK OF INDIA" },
        { short: "IDIB", full: "INDIAN BANK" },
        { short: "CBIN", full: "CENTRAL BANK OF INDIA" },
        { short: "CNRB", full: "CANARA BANK" },
        { short: "MAHB", full: "BANK OF MAHARASHTRA" },
        { short: "PSIB", full: "PUNJAB AND SIND BANK" },
        { short: "IOB", full: "INDIAN OVERSEAS BANK" },
        { short: "UCO", full: "UCO BANK" },
        // { short: "AIRTEL", full: "AIRTEL PAYMENTS BANK" },
        // { short: "IPPB", full: "INDIA POST PAYMENTS BANK" },
        { short: "HDFC", full: "HDFC Bank" },
        { short: "ICICI", full: "ICICI Bank" },
        { short: "UTIB", full: "Axis Bank" },
        { short: "IBKL", full: "IDBI BANK" },
        { short: "INDB", full: "IndusInd Bank" },
        { short: "KKBK", full: "Kotak Mahindra Bank" }
    ];


     const highlightedBanks = bankMappings
        .map(item => {
            // debugger
            const foundBank = allBanks.find(b => {
                // console.log(b.BankName, item.full)
                const jsonName = b.bank_code?.toLowerCase().trim();
                const mappingName = item.short.toLowerCase().trim();
                // console.log(jsonName, mappingName)
                return jsonName === mappingName || jsonName.includes(mappingName) || mappingName.includes(jsonName);
            });
            console.log(foundBank)
            return foundBank ? { label: item.short, bank: foundBank } : null;
        })
        .filter(x => x !== null);


    // const highlightedBanks = bankMappings
    //     .map(item => {
    //         const foundBank = allBanks.find(b => {
    //             const jsonName = (b.bank_name || "").toLowerCase().trim();
    //             const jsonCode = (b.bank_code || "").trim();
                
    //             // if (item.short === "BOI" && jsonCode === "BKID") return true;
    //             // if (item.short === "SBI" && jsonCode === "SBIN") return true;
    //             // if (item.short === "PNB" && jsonCode === "PUNB") return true;

    //             if (item.short === "BOI") {
    //                 return jsonCode === "BKID";
    //             }

    //             const mappingName = item.full.toLowerCase().trim();
    //             return jsonName === mappingName || jsonName.includes(mappingName) || mappingName.includes(jsonName);
    //         });

    //         if (foundBank && foundBank.bank_code?.trim() === "BKID") {
    //             return { 
    //                 label: "BOI", 
    //                 bank: { ...foundBank, bank_name: "Bank of India" } 
    //             };
    //         }

    //         return foundBank ? { label: item.short, bank: foundBank } : null;
    //     })
    //     .filter(x => x !== null);

    const safeSearchTerm = (searchTerm || "").toLowerCase();
    const filteredOtherBanks = allBanks.filter((b) => 
        b.bank_name && b.bank_name.toLowerCase().includes(safeSearchTerm)
    );

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsDropdownOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const handleBankSelection = async (selectedBankName, selectedBankCode) => {
        setBank(selectedBankName);
        setBankCode(selectedBankCode);
        setIfsc(""); 
        setErrors((p) => ({ ...p, bank: "", ifsc: "" }));

        try {
            const res = await fetchIfscApi(null, `?bankCode=${selectedBankCode}`);
            const fetchedIfsc = res?.ifsc || res?.IFSC || res?.IfscCode || res?.data || (typeof res === 'string' ? res : "");
            
            if (fetchedIfsc && typeof fetchedIfsc === 'string') {
                setIfsc(fetchedIfsc.toUpperCase());
            }
        } catch (error) {
            console.error("Failed to fetch IFSC:", error);
        }
    };

    // ✅ NEW: Validation now checks if verify action is false AND input is shown
    const validate = (isVerify) => {
        const err = {};
        if (!bank) err.bank = "Select bank";
        if (!ifsc) err.ifsc = "Enter IFSC";
        if (!accountNumber || accountNumber.length < 6) err.accountNumber = "Invalid account number";
        
        if (!isVerify && showNameInput && !beneficiaryName.trim()) {
            err.beneficiaryName = "Enter beneficiary name";
        }

        setErrors(err);
        return Object.keys(err).length === 0;
    };

    // ✅ NEW: Handles revealing the input field vs proceeding to submit
    const handleActionClick = (verifyFlag) => {
        if (verifyFlag) {
            // Hide the input and clear related errors if switching to Verify & Add
            setShowNameInput(false);
            setErrors((p) => ({ ...p, beneficiaryName: "" }));
        } else {
            // If Add Without Verify is clicked but input isn't shown yet, reveal it and stop
            if (!showNameInput) {
                setShowNameInput(true);
                return; 
            }
        }

        if (!validate(verifyFlag)) return;
        setIsVerifyAction(verifyFlag);
        setShowConfirm(true);
    };

    const handleAddBeneficiarySubmit = async () => {
        setShowConfirm(false);
        setIsLoading(true);

        try {
            const payload = {
                mid: username,
                beneAccount: accountNumber,
                beneIfsc: ifsc.toUpperCase(),
                bankCode: bankCode,
                benePincode: "110001", 
                remitterMobile: remitter_mobile,
                isVerified: isVerifyAction 
            };

            // ✅ Only attach beneName to the payload if it is NOT a Verify Action
            if (!isVerifyAction) {
                payload.beneName = beneficiaryName;
            }

            const res = await addBene(payload);

            if (res && (res.status === "SUCCESS" || res.status_code === 200)) {
                setPopupMessage(res.message || "Beneficiary Added Successfully");
                setPopupType("success");
                setShowPopup(true);

                dispatch(fetchWalletBalance());
                dispatch(fetchAepsBalance());
                dispatch(fetchSettlementBalance());

                setTimeout(() => {
                    navigate(-1, { state: { fetchbeneficiares: true } });
                }, 800);
            } else {
                throw new Error(res?.message || "Failed to add beneficiary parameters.");
            }
        } catch (e) {
            setPopupMessage(e?.message || "Something went wrong structural error");
            setPopupType("error");
            setShowPopup(true);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-gradient-to-br from-slate-50 via-indigo-50 to-cyan-50 px-2 py-3 sm:px-6 sm:py-6 flex flex-col items-center">
            <div className="w-full max-w-4xl bg-white rounded-2xl border border-slate-200 p-4 sm:p-6 space-y-5 shadow-sm text-start">
                
                <div className="mb-4">
                    <h2 className="text-2xl font-extrabold text-slate-900">Beneficiary Management</h2>
                    <p className="text-sm text-slate-500 mt-1">Add system details manually.</p>
                </div>

                {/* ===== BANK LOGIC ROWS ===== */}
                <div className="flex flex-col md:flex-row md:items-start relative overflow-visible">
                    <h3 className="text-base sm:text-sm font-semibold text-slate-600 mb-2 md:mb-0 md:w-[23%] shrink-0 pt-2">Bank Name</h3>
                    <div className="w-full md:w-[77%] relative">
                        <div className="grid grid-cols-2 min-[400px]:grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-6 gap-2">
                            {highlightedBanks.map(({ label, bank: bObj }, index) => {
                                const colors = [
                                    "bg-blue-700", "bg-red-600", "bg-orange-600", "bg-indigo-900",
                                    "bg-rose-600", "bg-blue-800", "bg-blue-600", "bg-teal-600",
                                    "bg-sky-600", "bg-orange-500", "bg-indigo-700", "bg-green-600",
                                    "bg-purple-600", "bg-cyan-600", "bg-red-500", "bg-orange-700",
                                    "bg-pink-600", "bg-violet-600", "bg-emerald-600", "bg-fuchsia-600"
                                ];
                                return (
                                    <button
                                        key={bObj.bank_code}
                                        type="button"
                                        onClick={() => handleBankSelection(bObj.bank_name, bObj.bank_code)}
                                        className={`h-16 rounded-xl text-white font-bold text-sm shadow leading-tight break-words ${colors[index % colors.length]} ${bankCode === bObj.bank_code ? "ring-4 ring-green-300" : ""} w-full`}
                                    >
                                        <div>{label}</div>
                                        <div className="text-[10px] mt-1 opacity-90">{bObj.bank_name}</div>
                                    </button>
                                );
                            })}
                            <button
                                type="button"
                                onClick={() => setShowOtherBanks(!showOtherBanks)}
                                className="h-16 rounded-xl bg-blue-900 text-white font-bold text-xs sm:text-sm shadow w-auto"
                            >
                                OTHER BANKS
                            </button>
                        </div>
                        {errors.bank && <p className="text-xs text-red-600 mt-2">{errors.bank}</p>}

                        {/* SEARCH BAR POPUP BLOCK */}
                        {showOtherBanks && (
                            <div className="mt-4 relative" ref={dropdownRef}>
                                <input
                                    type="text"
                                    placeholder="Search and filter other global banks..."
                                    value={searchTerm}
                                    onChange={(e) => {
                                        setSearchTerm(e.target.value);
                                        setIsDropdownOpen(true);
                                    }}
                                    onFocus={() => setIsDropdownOpen(true)}
                                    className="w-full h-12 border border-slate-400 rounded-lg px-4 text-base focus:border-indigo-600 focus:outline-none bg-white"
                                />
                                {isDropdownOpen && (
                                    <div className="absolute z-50 w-full mt-1 bg-white border border-slate-400 rounded-lg shadow-2xl max-h-80 overflow-y-auto">
                                        {filteredOtherBanks.length > 0 ? (
                                            filteredOtherBanks.map((b) => (
                                                <div
                                                    key={b.bank_code}
                                                    onClick={() => {
                                                        handleBankSelection(b.bank_name, b.bank_code);
                                                        setSearchTerm(b.bank_name);
                                                        setIsDropdownOpen(false);
                                                    }}
                                                    className="px-4 py-3 hover:bg-slate-100 cursor-pointer text-slate-700 border-b last:border-b-0 text-sm font-medium"
                                                >
                                                    {b.bank_name}
                                                </div>
                                            ))
                                        ) : (
                                            <div className="px-4 py-3 text-slate-500 text-sm">No banks found matching "{searchTerm}"</div>
                                        )}
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </div>

                {/* ===== ACCOUNT NUMBER ===== */}
                <div className="flex flex-col md:flex-row md:items-center">
                    <label className="text-base sm:text-sm font-semibold text-slate-600 mb-2 md:mb-0 md:w-[23%] shrink-0">
                        Account Number
                    </label>
                    <div className="w-full md:w-[77%] flex flex-col">
                        <input type="text" name="fake-user" autoComplete="username" style={{ display: "none" }} />
                        <input
                            className="w-full px-4 py-4 text-lg rounded-xl border border-slate-400"
                            value={accountNumber}
                            type="text"
                            name="_accoun1t_number1_"
                            inputMode="numeric"
                            autoComplete="off"
                            onChange={(e) => setAccountNumber(e.target.value.replace(/\D/g, ""))}
                            placeholder="Enter Bank Account Number"
                        />
                        {errors.accountNumber && <p className="text-xs text-red-600 mt-1">{errors.accountNumber}</p>}
                    </div>
                </div>

                {/* ===== IFSC CONFIGURATION ===== */}
                <div className="flex flex-col md:flex-row md:items-center">
                    <label className="text-base sm:text-sm font-semibold text-slate-600 mb-2 md:mb-0 md:w-[23%] shrink-0">
                        IFSC Code
                    </label>
                    <div className="w-full md:w-[77%] flex flex-col">
                        <input
                            value={ifsc}
                            onChange={(e) => {
                                setIfsc(e.target.value.toUpperCase());
                                setErrors((p) => ({ ...p, ifsc: "" }));
                            }}
                            disabled={loadingIfsc}
                            className={`w-full px-4 py-3 rounded-xl border border-slate-400 ${loadingIfsc ? "bg-slate-100 text-slate-500" : "bg-white"}`}
                            placeholder={loadingIfsc ? "Fetching IFSC..." : "Enter IFSC"}
                        />
                        {errors.ifsc && <p className="text-xs text-red-600 mt-1">{errors.ifsc}</p>}
                    </div>
                </div>

                {/* ===== BENEFICIARY NAME (✅ Conditionally Displayed) ===== */}
                {showNameInput && (
                    <div className="flex flex-col md:flex-row md:items-center animate-[fadeIn_.3s_ease-out]">
                        <label className="text-base sm:text-sm font-semibold text-slate-600 mb-2 md:mb-0 md:w-[23%] shrink-0">
                            Beneficiary Name
                        </label>
                        <div className="w-full md:w-[77%] flex flex-col">
                            <input
                                className="w-full px-4 py-4 text-lg rounded-xl border border-slate-400 focus:border-[#12345A] focus:outline-none"
                                value={beneficiaryName}
                                placeholder="Enter Beneficiary Name"
                                onChange={(e) => {
                                    setBeneficiaryName(e.target.value);
                                    if (errors.beneficiaryName) setErrors((p) => ({ ...p, beneficiaryName: "" }));
                                }}
                            />
                            {errors.beneficiaryName && <p className="text-xs text-red-600 mt-1">{errors.beneficiaryName}</p>}
                        </div>
                    </div>
                )}

                {/* ===== ACTION TRIGGER LAYOUTS ===== */}
                <div className="pt-4 border-t border-slate-200 flex flex-col sm:flex-row gap-4">
                    <button
                        type="button"
                        onClick={() => handleActionClick(true)} 
                        disabled={isLoading}
                        className="flex-1 py-4 text-lg rounded-2xl font-bold bg-[#12345A] hover:bg-[#0F2E47] text-white shadow-md transition-colors disabled:opacity-50"
                    >
                        Verify & Add (₹3)
                    </button>
                    <button
                        type="button"
                        onClick={() => handleActionClick(false)} 
                        disabled={isLoading}
                        className="flex-1 py-4 text-lg rounded-2xl font-bold border-2 border-[#12345A] text-[#12345A] bg-white hover:bg-slate-50 transition-colors disabled:opacity-50"
                    >
                        Add Without Verify (₹0)
                    </button>
                </div>
            </div>

            {/* ===== ACTION CONFIRMATION OVERLAY MODAL ===== */}
            {showConfirm && (
                <div className="fixed inset-0 z-50 bg-black/40 flex items-end sm:items-center justify-center p-0 sm:p-4">
                    <div className="bg-white w-full sm:max-w-md rounded-t-2xl sm:rounded-2xl p-5 sm:p-6 space-y-4 shadow-2xl">
                        <h3 className="text-base sm:text-lg font-semibold text-slate-800">Confirmation</h3>
                        <p className="text-sm text-slate-700 leading-relaxed">
                            {isVerifyAction ? (
                                <>
                                    <b>English:</b><br />
                                    <strong>₹3</strong> will be deducted from your wallet for account verification. Are you sure you want to verify and add this beneficiary?<br /><br />
                                    <b>हिंदी:</b><br />
                                    खाता सत्यापन के लिए आपके वॉलेट से <strong>₹3</strong> काटे जाएंगे। क्या आप वाकई इस लाभार्थी को सत्यापित करके अपनी सूची में जोड़ना चाहते हैं?
                                </>
                            ) : (
                                <>
                                    <b>English:</b><br />
                                    Are you sure you want to add this beneficiary without verification? (<strong>₹0</strong> charge)<br /><br />
                                    <b>हिंदी:</b><br />
                                    क्या आप बिना सत्यापन के इस लाभार्थी को जोड़ना चाहते हैं? (<strong>₹0</strong> शुल्क)
                                </>
                            )}
                        </p>
                        <div className="flex gap-3 pt-2">
                            <button onClick={() => setShowConfirm(false)} className="flex-1 py-4 text-lg bg-slate-100 text-slate-700 rounded-2xl font-bold hover:bg-slate-200 transition-colors">
                                Cancel
                            </button>
                            <button onClick={handleAddBeneficiarySubmit} className="flex-1 py-4 text-lg bg-[#12345A] text-white rounded-2xl font-bold hover:bg-[#0F2E47] transition-colors">
                                Confirm
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {showPopup && (
                <Popup
                    message={popupMessage}
                    type={popupType}
                    onClose={() => setShowPopup(false)}
                />
            )}
        </div>
    );
};

export default AddBeneficiarySolitech;